<section class="dynamic-collapse-header">
	<div class="ovale" *ngIf="section.items.length==0"><span>No Items Added</span></div>
	<h3>
		<span class="title">{{section.sectionName}}</span>
		<div class="label" *ngIf="section.grandTotal>0">{{section.itemCount}}</div>
	</h3>
	<ng-container
		*ngIf="dataIsLoaded && isNFZ==false && (planCategory == 'categoryAssets' || planCategory == 'categoryDebts')">
		<div class="total-count" *ngIf="section.grandTotal>=0">{{section.grandTotal |
			currency:'GBP':'symbol-narrow':'1.0'}}</div>
		<div class="total-count" *ngIf="section.grandTotal<0" style="color:red">
			({{section.grandTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
		</div>
	</ng-container>
</section>
<section class="dynamic-collapse-main">
	<section class="dynamic-collapse-content">
		<section class="plan-review-data-user" *ngFor="let item of section.items;let i = index;">
			<div class="item-managment">
				<div class="item">
					<!-- <img src="../../assets/../../assets/img/{{themeService.theme}}/check-item.svg.svg" alt=""> -->
					<div class="svg-container check-item-svg-container">
						<svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle cx="19" cy="19" r="18.5" stroke="black" stroke-opacity="0.2" />
							<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
								height="38">
								<circle cx="18.9999" cy="19" r="17.0526" fill="#C4C4C4" />
								<circle cx="18.9999" cy="19" r="17.5526" stroke="black" stroke-opacity="0.4" />
							</mask>
							<g mask="url(#mask0)">
								<circle class="svg-background" cx="19" cy="19" r="15" />
							</g>
							<path class="svg-sign"
								d="M11.0496 20.1323C11.1729 19.9157 11.4875 19.9129 11.7756 20.1609L14.675 22.1877C14.8322 22.2826 14.9826 22.3311 15.1272 22.3311C15.4263 22.3311 15.6631 22.1174 15.8918 21.9116L25.17 12.7011C25.7502 12.0754 26.3143 11.8548 26.6825 12.0948C26.8525 12.2056 26.9625 12.3725 26.992 12.5651C27.0271 12.7936 26.9464 13.0399 26.7649 13.2582L15.6089 26.6977C15.447 26.8925 15.2408 27 15.0287 27C14.7769 27 14.5488 26.8497 14.4018 26.588L11.1274 20.7338C10.992 20.5151 10.962 20.2878 11.0496 20.1323Z" />
						</svg>
					</div>
					<div class="item-name">{{item.itemName}}</div>
				</div>
				<div class="btn-managment">
					<input type="button" class="btn btn btn-primary primary-sml-btn view" value="View"
						(click)="view(item.Id)">
					<div class="delete-btn-group">
						<input type="button" class="btn btn-primary primary-sml-btn delete"
							(click)="callDialog(item.Id,item.itemName)" value="Delete">
						<i class="fa fas fa-trash"></i>
					</div>
				</div>
			</div>
			<ng-container *ngIf="dataIsLoaded && isNFZ==false">
				<div class="get-total-count" *ngIf="planCategory == 'categoryAssets' || planCategory == 'categoryDebts'"
					placement="top" ngbTooltip="{{sectionName}}">
					<div class="total-count" *ngIf="item.itemTotal>=0">
						{{item.itemTotal | currency:'GBP':'symbol-narrow':'1.0'}}</div>
					<div class="total-count" *ngIf="item.itemTotal<0" style="color:red">
						({{item.itemTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
					</div>
				</div>
			</ng-container>
		</section>
		<div class="plan-review-btn-add-item" (click)="add()" *ngIf="section.items.length > 0">
			<span>+ Add</span>
		</div>
		<div class="description-empty-section" *ngIf="section.items.length==0">
			<div class="plan-review-empty-btn-add-item" (click)="add()">
				<span>+ Add</span>
			</div>
		</div>
	</section>
</section>

<app-dialog [visible]="showDialog" [itemName]="itemNameforDialog" [sectionName]="section.sectionTitle"
	(dialogAnswer)="deleteByEvent($event)">
</app-dialog>